module.exports = __webpack_public_path__ + "static/img/dream-info.295df04a.png";